import { isAndroid, isIphoneLike, isIpadLike } from "@pjs/utilities";
import { EditorCache } from "./EditorCache";

const editorCount = isAndroid || isIphoneLike || isIpadLike ? 4 : 8;

export const editorCacheInstance = new EditorCache(editorCount);
